<template>
  <div class="newPitData no-select">
    <!-- 新增分组 -->
    <MapModal
      class="newModelPosition hierarchy2"
      :modalNode="modalNode"
      :title="newPitDataCategory.title"
      :id="newPitDataCategory.id"
      :close="closeOneSelf"
    >
      <template slot="content">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="settings"
          label-width="80px"
        >
          <el-form-item
            label="选择分组"
            prop="modelName"
            v-if="isPitData.isShow"
          >
            <el-autocomplete
              :fetch-suggestions="querySearchAsync"
              v-model="form.modelName"
              placeholder="请选择分组"
              value-key="name"
              @select="autoCompleteSelect"
              :debounce="10"
              ref="removeSuggestions"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="修改类型">
            <el-radio-group v-model="form.changeType" style="padding-top:7px">
              <el-radio label="2">模型裁切</el-radio>
              <el-radio label="1">地形裁切</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="修改方式" class="changeWay btns">
            <!-- 重写 -->
            <el-radio-group v-model="form.changeWay">
              <div class="changeWayDivStyle" style="margin-bottom: 20px;">
                <el-radio label="1" style="vertical-align: middle; !important"
                  >手动描点</el-radio
                >
                <el-button
                  type="primary"
                  :disabled="form.changeWay == 2"
                  @click="addPolygon"
                  >选择区域</el-button
                >
              </div>
              <div class="changeWayDivStyle">
                <el-radio label="2">导入区域点</el-radio>
                <el-upload
                  :disabled="form.changeWay == 1"
                  class="upload-demo"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  multiple
                  :limit="1"
                  :show-file-list="false"
                  :http-request="httpRequest"
                  :on-success="handleSuccess"
                  ref="elUploadRef"
                >
                  <el-button type="primary" :disabled="form.changeWay == 1"
                    >导入文件</el-button
                  >
                </el-upload>
                <!-- <el-button type="primary">导入文件</el-button> -->
              </div>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="裁切深度(米)" v-if="form.changeType == 1">
            <el-input
              v-model.number="form.cuttingHeight"
              placeholder="请输入深度"
            ></el-input>
          </el-form-item>
          <el-form-item label="名称" v-if="form.changeWay == 1">
            <el-input v-model="form.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item class="submitBtn btns">
            <el-button @click="closeOneSelf">取消</el-button>
            <el-button type="primary" @click="onSubmit('form')">确定</el-button>
          </el-form-item>
        </el-form>
      </template>
    </MapModal>
  </div>
</template>
<script>
import _ from "lodash";
import {
  searchBimModelNodeGrouping,
  addBimModelExcavationDetails,
} from "@/api/api";
import axios from "axios";
import { terrainList, getServeTerrainList } from "@/mapUtils/TerrainUtils.js";
const MapModal = () => import("@/components/common/mapModal/Index");

export default {
  name: "newPitData",
  components: { MapModal },
  props: ["isPitData"],
  data() {
    return {
      newPitDataCategory: {
        title: "新增",
        id: " newPitData", // id和ref使用的同一个
      },
      modalNode: {
        newPitDataCategory: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 55,
          //   y: -720,
          // },
          // width: "450px", // 宽度配置 默认450px
          height: "410px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
        },
      },
      rules: {
        modelName: [
          { required: true, message: "请选择关联模型", trigger: "change" },
        ],
      },
      form: {
        name: "",
        modelName: "",
        changeType: "2",
        changeWay: "1",
        cuttingHeight: 0,
      },
      submitData: {
        projectId: "", // 当前项目id
        pitType: 1, //模型还是地形
        embsId: "", //一切模型id
        name: "", //保存坑的名字
        pId: "", // 当前保存id
        excavationDetails: { excavationDetails: "", depth: 1 }, // 坑数据
      },
    };
  },
  methods: {
    // 关闭自己
    closeOneSelf() {
      this.$emit("closeNewPitData");
    },
    // 远程搜索展示下拉数据（防抖1s）
    querySearchAsync: _.debounce(function(queryString, cb) {
      // 获取session存储的当前项目id和当前输入框输入的value
      const params = {
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
        name: queryString,
        pId: 0,
      };
      // 发送请求调用回调展示数据
      searchBimModelNodeGrouping(params).then((res) => {
        cb(res.data.data);
      });
    }, 500),
    // 远程搜索框选中了
    autoCompleteSelect(item) {
      const { projectId, id, embsId } = item;
      this.submitData.projectId = projectId;
      this.submitData.pId = id;
      this.submitData.embsId = embsId;
      if (this.form.changeType == 2) {
        const model = viewShed.inquire("modelArray", "modelId", embsId);
        if (model && model.uid && this.$GLOBAL.map.hasLayer(model.uid)) {
          this.$GLOBAL.tilesetLayer = this.$GLOBAL.map.getLayerById(model.uid);
        } else {
          this.$notify({
            title: "当前节点不可见!",
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
          this.submitData.projectId = ""; //相当于是项目id
          this.submitData.pId = ""; //相当于是parentId
          this.submitData.embsId = "";
          if (this.$GLOBAL.terrainClipGraphic) {
            this.$GLOBAL.terrainClipGraphic.stopDraw();
          }
        }
      }
    },
    // 地形裁切and模型裁切（多边形方式）
    addPolygon() {
      console.log(this.$GLOBAL.terrainClipGraphic.startDraw);
      if (!this.submitData.projectId && !this.submitData.pId) {
        this.$notify({
          title: "请先选择节点,并在可见范围内！",
          message: "",
          type: "error",
          duration: 960,
          offset: 320,
        });
        return;
      }
      // 地形裁切
      if (this.form.changeType == 1) {
        // 开始绘制
        this.$GLOBAL.terrainClipGraphic.startDraw({
          type: "polygon",
          style: {
            color: "#007be6",
            opacity: 0.5,
            outline: false,
          },
          //绘制成功后回调
          success: (graphic) => {
            // 如果是修改挖坑或者是重复挖新的（等同于修改），在绘制完成之后把旧的那个坑删除
            if (this.submitData.kId) {
              this.$GLOBAL.terrainClip.removeArea(this.submitData.kId);
            }
            let positions = graphic.positionsShow;
            this.$GLOBAL.terrainClipGraphic.clear();
            // 获取当前挖洞的坐标点
            const newPositions = mars3d.PointTrans.cartesians2lonlats(
              positions
            );
            // 存储到form表单的坐标当中
            this.submitData.excavationDetails.excavationDetails = newPositions;
            // 获取到添加的挖洞数据的返回结果
            const regionalobject = this.$GLOBAL.terrainClip.addArea(
              newPositions,
              {
                diffHeight: this.form.cuttingHeight,
              }
            );
            // 存储对应那个坑的ID
            this.submitData.kId = regionalobject.id;
            this.$notify({
              title: `裁切成功。`,
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
          },
        });
      } else if (this.form.changeType == 2) {
        // 模型裁切
        this.$GLOBAL.terrainClipGraphic
          .startDraw({
            type: "polygon",
            style: {
              color: "#007be6",
              opacity: 0.2,
              outline: false,
            },
          })
          .then((graphic) => {
            // 如果是修改挖坑或者是重复挖新的（等同于修改），在绘制完成之后把旧的那个坑删除
            if (this.submitData.kId) {
              this.$GLOBAL.tilesetLayer.clip.removeArea(this.submitData.kId);
            }
            // 绘制成功后回调
            const positions = graphic.positionsShow;
            this.$GLOBAL.terrainClipGraphic.clear();
            this.submitData.excavationDetails.excavationDetails = mars3d.LngLatArray.toArray(
              positions
            );
            const regionalobject = this.$GLOBAL.tilesetLayer.clip.addArea(
              positions
            );
            // 暂储对应那个坑的ID
            this.submitData.kId = regionalobject.id;
            this.$notify({
              title: `裁切成功。`,
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
          });
      }
    },
    // 点击上传
    httpRequest(item) {
      this.submitData.pitType = Number(this.form.changeType);
      this.submitData.excavationDetails.depth = this.form.cuttingHeight;
      if (!this.submitData.projectId && !this.submitData.pId) {
        this.$notify({
          title: "请先选择节点！",
          message: "",
          type: "error",
          duration: 960,
          offset: 320,
        });
        return;
      }
      const { projectId, pId, pitType, embsId } = this.submitData;
      let formData = new FormData();
      formData.append("file", item.file);
      formData.append("projectId", projectId);
      formData.append("pId", pId);
      formData.append("pitType", pitType);
      formData.append("embsId", embsId);
      axios
        .post("/baseIP/BimModelExcavationDetails/addKml", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + window.sessionStorage.getItem("token"),
            "X-Authorization":
              "Bearer " + window.sessionStorage.getItem("refreshToken"),
          },
        })
        .then((res) => {
          if (res.data.code === 204 || res.data.code === 200) {
            this.SubmitSuccessfully("上传", "form");
            this.closeOneSelf();
          } else {
            this.$notify({
              title: `导入失败。`,
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
          }
        });
    },
    // 上传成功之后
    handleSuccess() {
      this.$refs.elUploadRef.clearFiles();
    },
    // 关于保存提交之后的统一操作
    SubmitSuccessfully(name, formName) {
      // 通知栏
      this.$notify({
        title: `${name}成功。`,
        message: "",
        type: "success",
        duration: 960,
        offset: 320,
      });
      getServeTerrainList();
      // // 清除表单
      this.$refs[formName].resetFields();
      // 发送事件给父组件告知提交完毕
      this.$emit("onSubmitSuccess");
    },
    // 提交
    onSubmit(formName) {
      if (this.form.changeWay == 2) {
        return;
      }
      this.$refs[formName].validate((valid) => {
        // 校验成功
        if (valid) {
          if (!this.submitData.kId && this.form.changeWay == 1) {
            this.$notify({
              title: `请选择区域`,
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
            return;
          }
          if (!this.form.name && this.form.changeWay == 1) {
            this.$notify({
              title: `请填写名称`,
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
            return;
          }
          // 组装数据
          this.submitData.pitType = Number(this.form.changeType);
          this.submitData.name = this.form.name;
          this.submitData.excavationDetails.depth = this.form.cuttingHeight;
          let newTerrainForm = JSON.parse(JSON.stringify(this.submitData));
          newTerrainForm.excavationDetails = JSON.stringify(
            newTerrainForm.excavationDetails
          );
          addBimModelExcavationDetails(newTerrainForm).then((res) => {
            const terrainObject = {
              id: this.submitData.embsId,
              list: [
                {
                  kId: res.data.data,
                  uId: this.submitData.kId,
                  typeJudgment: this.submitData.pitType,
                },
              ],
            };
            if (terrainList && terrainList.length > 0) {
              terrainList.forEach((item) => {
                if (item.id == this.submitData.embsId) {
                  let newArr = item.list.concat(terrainObject.list);
                  item.list = newArr;
                }
              });
              if (
                !terrainList.find((item) => item.id == this.submitData.embsId)
              ) {
                terrainList.push(terrainObject);
              }
            } else {
              terrainList.push(terrainObject);
            }
            this.SubmitSuccessfully("新增", formName);
            // 请求完毕之后也要关闭自己
            this.closeOneSelf();
          });
        } else {
          // 校验失败
          return false;
        }
      });
    },
  },
  mounted() {
    // 是二级分组新增 赋值对应数据
    if (!this.isPitData.isShow) {
      this.autoCompleteSelect(this.isPitData);
    }
  },
};
</script>
<style lang="scss">
@import "../../../assets/scss/box.scss";
.newPitData {
  @include box_wh(320, 560, true, 386);
  padding: 0;
  overflow-y: auto;
  h3 {
    text-indent: 14px;
  }
  .el-form.settings {
    width: 100%;
    @include hvcenter(column);
    // padding: 8px 0 0 0;
    padding-top: 8px;
    .el-form-item {
      width: 100%;
      padding: 0 0 0 7px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 18px;
      .el-form-item__label {
        margin-bottom: 0px;
        font-size: 12px;
        @include font_color("t_color_op1");
        padding: 0;
        flex-grow: 0;
        line-height: 32px;
        padding-right: 10px;
      }
      .el-form-item__content {
        margin-left: 0px !important;
        font-size: 12px;
        display: flex;
        align-items: center;
        flex-grow: 1;
        line-height: 32px;
        .el-select {
          @include select_base();
        }
        .el-autocomplete {
          @include select_base();
        }
        .el-input {
          @include input_base();
        }
        .el-textarea {
          @include textarea_base();
        }
        .el-checkbox {
          @include checkbox_base();
        }
      }
      .showInline {
        margin: 10px 6px;
        width: 96px;
        display: inline-block;
        text-align: right;
        @include lheight(26);
        font-size: 11px;
        @include font_color("t_color_op1");
        .el-input-number {
          margin-left: -5px !important;
          @include input_number();
        }
        .el-input-number__increase {
          height: 32px;
          line-height: 32px;
        }
        .el-input__inner {
          width: 100% !important;
        }
      }
      &:first-child {
        padding: 10px 0 0 7px;
      }
      &.description {
        margin-bottom: 12px;
      }
      &.file-upload {
        margin-bottom: 6px;
        /*避免动画效果导致滚动条出现*/
        max-height: 120.3px;
        overflow-y: hidden;
        .el-form-item__label {
          align-self: flex-start;
        }
        .el-form-item__content {
          .upload-demo {
            .el-upload__input {
              display: none;
            }
            .el-upload {
              .el-button--default {
                @include lheight(26);
                @include font_color("t_color_op2");
                @include background_color("t_color3_op2");
                @include border_color("t_color_op2");
                padding: 0 10px;
                margin: 0;
                span {
                  @include lheight(24);
                  font-size: 12px;
                  display: block;
                  text-align: center;
                }
                &:hover {
                  @include background_color("t_color3_op1");
                  @include border_color("t_color_op1");
                  @include font_color("t_color_op1");
                }
              }
            }
            .el-upload__tip {
              margin-top: 0px;
              @include lheight(22);
              span {
                @include font_color("t_color_op2");
                @include lheight(22);
              }
            }
            .el-upload-list {
              .el-upload-list__item {
                //去掉动画效果
                //transition: none !important;

                margin-top: 0px;
                background: none;
                a {
                  @include font_color("t_color_op2");
                }
                .el-upload-list__item-name {
                  margin-right: 20px;
                  @include font_color("t_color_op2");
                  @include textOverflow();
                  font-size: 12px;
                  max-width: 200px;
                  i {
                    @include font_color("t_color_op2");
                  }
                }
                .el-upload-list__item-status-label {
                  line-height: 22px;
                  .el-icon-upload-success {
                    @include font_color("t_color_op2");
                    line-height: 22px;
                  }
                }
                i {
                  top: 4px;
                  @include font_color("t_color_op2");
                  &.el-icon-close-tip {
                    display: none;
                  }
                }
                .el-progress {
                  .el-progress-bar__inner {
                    @include background_color("t_color1_op2");
                  }
                  .el-progress__text {
                    @include font_color("t_color_op2");
                  }
                }
                &:first-child {
                  margin-top: 0px;
                }
                &:hover {
                  @include background_color("slide_color_op1");
                  .el-upload-list__item-name {
                    @include font_color("t_color_op1");
                    i {
                      @include font_color("t_color_op1");
                    }
                  }
                  i.el-icon-close {
                    @include font_color("t_color_op1");
                  }
                }
              }
            }
          }
        }
      }
      &.color-pick {
        margin-bottom: 2px;
        .el-color-picker {
          /* height: 26px !important; */
          height: 20px !important;
          line-height: 20px !important;
          width: 20px;
          padding: 0;

          .el-color-picker__trigger {
            border: none;
            height: 20px !important;
            line-height: 20px !important;
            width: 20px;
            padding: 0;
            .el-color-picker__color {
              border: none;
            }
            span.el-icon-arrow-down {
              // display: none;
            }
          }
        }
        span.label-text {
          @include font_color("t_color_op1");
          margin-left: 16.5px;
        }
      }

      &.btns {
        margin-bottom: 12px;
        .el-form-item__content {
          width: 166px;
          @include button_primary();
          @include button_default();
        }
      }
    }
  }
}

.el-color-dropdown.icon-color-picker {
  .el-color-dropdown__main-wrapper {
    // display: none;
  }
  .el-color-dropdown__btns {
    .el-color-dropdown__value {
      // display: none;
    }
  }
  .el-color-predefine {
    .el-color-predefine__colors {
      .el-color-predefine__color-selector {
        border: 1px solid #2ca9e1;
        box-sizing: border-box;
      }
    }
  }
}

.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #f6f6f6 !important;
}
.el-autocomplete-suggestion li {
  color: #606266 !important;
  font-size: 12px;
}
.el-autocomplete-suggestion li:hover {
  @include background_color("t_color1_op1");
  color: white !important;
  font-size: 12px;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: white !important;
}
.el-radio {
  white-space: break-spaces;
  word-break: break-all;
  .el-radio__input {
    line-height: 18px;
    .el-radio__inner {
      margin: 0 3px 0 0;
      @include background_color("t_color3_op2");
      &::after {
        /* 取消选中状态单选框中间的小圆点显示 */
        display: none;
      }
      &:hover {
        @include border_color("t_color1_op1");
      }
    }
    &.is-checked {
      .el-radio__inner {
        // @include border_color('t_color1_op1');
        // @include background_color('t_color1_op1');
        @include border_color("th_color_op1");
        @include background_color("t_color1_op2");
      }
    }
  }
  .el-radio__label {
    padding-left: 2px;
    font-size: 12px !important;
    color: white;
  }
  &.is-checked {
    .el-radio__label {
      @include font_color("t_color_op1");
    }
    .el-radio__inner {
      background-color: #2281b2 !important;
      // @include background_color("t_color1_op1");
    }
  }
}

.submitBtn {
  display: flex;
  flex-direction: inherit !important;
  justify-content: flex-end;
  padding-left: 169px !important;
  padding-top: 10px !important;
  margin-bottom: 0px !important;
  margin-top: 0px !important;
}
.el-radio-group {
  margin-top: 0px !important;
}
.changeWayDivStyle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.changeWayDivStyle .el-radio {
  padding-top: 0px !important;
}
.changeWay {
  margin-bottom: 18px !important;
}
.changeWay .el-form-item__label {
  padding-bottom: 64px !important;
}
.newPitData
  .newModelPosition
  .el-form.settings
  .el-form-item.btns
  .el-form-item__content
  .el-button--primary.is-disabled
  span {
  color: rgba(255, 255, 255, 0.9) !important;
}
</style>
